import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">为什么数百万吃瓜群众选择吃瓜网站</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item) => (
            <div key={item.id} className="text-center bg-background-100 rounded-2xl p-8 border border-background-200/60">
              <span className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-2xl mx-auto mb-5">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </span>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}